import { NullableType } from '@/models'

const formatter = new Intl.NumberFormat('en-US')

export const formatNumber = (value: NullableType<number>): string => {
  if (value == null) return '0'
  return formatter.format(value)
}
